import type { TemplateOnlyComponent } from '@ember/component/template-only';
import type { DmpAdapter } from 'parog-web/cnam-adapters/dmp-adapter';
import fuiPopup from 'wise-fui-modules/modifiers/fui-popup';

export default <template>
  <div>
    Plus d'informations sur les autorisations
    <i
      class='question circle icon'
      {{fuiPopup position='right center' hoverable=true}}
    ></i>
    <div class='ui popup'>
      Une limite d'actualisation de parcours est appliquée :
      <ul>
        <li>{{@dmpAdapter.LIMIT_PER_HOUR}}
          actualisations par heure maximum</li>
        <li>{{@dmpAdapter.LIMIT_PER_DAY}}
          actualisations par jour maximum</li>
      </ul>
      Le nombre d'actualisations de parcours autorisées prend en compte le
      nombre d'actualisations déjà effectuées lors de la dernière heure et lors
      de la journée actuelle.
    </div>
  </div>
</template> satisfies TemplateOnlyComponent<{
  Args: {
    dmpAdapter: DmpAdapter;
  };
}>;
